import { uploadRequestFor } from "../domain/productComposer/upload";
import fetcher, {
  fetchErrorMessage,
  uploadWithProgress,
} from "../hooks/fetcher";

/* A rejected save resolves with its problems rather than throwing: they are data the
 * composer shows against the card or field they belong to. */
const send = ({ url, method, body }) =>
  fetcher(url, { method, body: JSON.stringify(body) })
    .then((data) => ({ ok: true, data }))
    .catch((error) => ({
      ok: false,
      problems: error.json?.problems ?? [],
      message: fetchErrorMessage(error),
    }));

export const createProducts = (body) =>
  send({ url: "/api/product/shopBuilder/batch", method: "POST", body });

export const updateProduct = ({ productId, body }) =>
  send({ url: `/api/product/shopBuilder/${productId}`, method: "PUT", body });

export const uploadProductImage = ({ file, onProgress, ...edit }) => {
  const { url, headers } = uploadRequestFor({ fileType: file.type, ...edit });

  return uploadWithProgress(url, file, { headers, onProgress })
    .promise.then((json) =>
      json.success
        ? { ok: true, image: json.image, quality: json.quality ?? "ok" }
        : { ok: false, message: json.error?.message ?? "Upload failed" },
    )
    .catch((error) => ({
      ok: false,
      message: error.json?.error?.message ?? "Upload failed",
    }));
};
